export function formatPhone(phone = '') {
    const digits = phone.replace(/\D/g, '');
    const us = digits.length === 11 && digits.startsWith('1') ? digits.slice(1) : digits;
    const m = us.match(/^(\d{3})(\d{3})(\d{4})$/);
    return m ? `(${m[1]}) ${m[2]}-${m[3]}` : phone;
}

export const telHref = (phone = '') => `tel:${phone.replace(/[^\d+]/g, '')}`;
export const smsHref = (phone = '') => `sms:${phone.replace(/[^\d+]/g, '')}`;

export const ensureHttps = (url = '') => (!url ? '' : /^https?:\/\//i.test(url) ? url : `https://${url}`);
export const prettyUrl = (url = '') => url.replace(/^https?:\/\/(www\.)?/i, '').replace(/\/$/, '');

const NICK_RE = /\s*["“”]([^"“”]+)["“”]\s*/;

// Splits `Benjamin "Scorp" Young` into display name + nickname when the API didn't.
export function splitName(profile = {}) {
    const raw = profile.name || '';
    const nickname = profile.nickname || raw.match(NICK_RE)?.[1]?.trim() || null;
    const displayName = profile.displayName || raw.replace(NICK_RE, ' ').replace(/\s+/g, ' ').trim() || raw;
    return { displayName, nickname, firstName: displayName.split(' ')[0] || displayName };
}

export function initials(name = '') {
    return name
        .split(/\s+/)
        .filter(Boolean)
        .map((w) => w[0])
        .slice(0, 2)
        .join('')
        .toUpperCase();
}

export function formatDateRange(start, end, isCurrent) {
    const f = (d) => (d ? new Date(d).toLocaleDateString('en-US', { month: 'short', year: 'numeric' }) : '');
    const s = f(start);
    const e = isCurrent ? 'Present' : f(end);
    if (!s && !e) return '';
    return s ? `${s} – ${e || 'Present'}` : e;
}

export const phoneLabel = (type, custom) =>
    type === 'other' && custom ? custom : { mobile: 'Mobile', work: 'Work', home: 'Home', other: 'Other' }[type] || type;

export const emailLabel = (type, custom) =>
    type === 'other' && custom ? custom : { personal: 'Personal', work: 'Work', other: 'Other' }[type] || type;

// Text color that stays readable on top of an accent color.
export function inkFor(hex = '#000000') {
    const n = parseInt(hex.replace('#', ''), 16);
    const [r, g, b] = [(n >> 16) & 255, (n >> 8) & 255, n & 255].map((c) => {
        const s = c / 255;
        return s <= 0.03928 ? s / 12.92 : ((s + 0.055) / 1.055) ** 2.4;
    });
    const L = 0.2126 * r + 0.7152 * g + 0.0722 * b;
    // 0.179 is where black and white text have equal contrast (WCAG).
    return L > 0.179 ? '#0b0b0c' : '#ffffff';
}
